import React from "react";
import { Separator } from "component/atoms/contextmenu/index";
import { inject, observer } from "mobx-react";
import Dropdown from "component/atoms/Dropdown";
/// message dispatcher
import pubsub from "global/global";
import CustomEvent from "core/customEvent";
import HotkeyModel from "models/hotkeyModel";
/** resources */
import Config from "config";
import SVGIcons from "assets/icon";

import Swal from "sweetalert2";
/**
 * @description Contrast 버튼 클릭시 나타나는 확장 메뉴. UI Component Container
 * @function ContrastDropdownMenu
 */
//const ContrastDropdownMenu: React.FunctionComponent = (props: any) => {
@inject("gridLayoutStore")
@inject("toolbarStore")
@inject("hotkeyStore")
@observer
class ContrastDropdownContainer extends React.PureComponent {
  tokenContrastDropdownRender = null;
  componentDidMount() {
    this.tokenContrastDropdownRender = pubsub.subscribe(
      CustomEvent.Messages.CONTRAST_DROPDOWN_RENDER,
      this.handleContrastDropdownRender
    );
  }

  componentWillUnmount() {
    pubsub.unsubscribe(this.tokenContrastDropdownRender);
  }
  handleContrastDropdownRender = (payload, msg) => {
    const { gridLayoutStore } = this.props;
    const { selectedValue } = payload;

    if (selectedValue === "ct-Negative") {
    } else {
      gridLayoutStore.setContrastOptionOnActiveDCMView(selectedValue);
    }

    this.setState({});
    this.forceUpdate();
  };
  /**
   * @method getSelectedValue
   * @description Active된 뷰포트의 Contrast mode 반환. 자유변환시에는 "" 빈 문자열 리턴
   * @returns
   */
  getSelectedValue = () => {
    const { gridLayoutStore } = this.props;
    const selectedValue = gridLayoutStore.getContrastOptionNameOnActiveDCMView();

    if (typeof selectedValue !== "string") {
      return "";
    }

    return selectedValue;
  };
  isActive(value) {
    const selectedValue = this.getSelectedValue();

    if (selectedValue === value) {
      return true;
    }
    return false;
  }

  /**
   * @method getIsNagative
   * @description Active된 뷰포트에 반전 효과 적용 여부 반환
   * @returns
   */
  getIsNagative = () => {
    const { gridLayoutStore } = this.props;
    const isNagative = gridLayoutStore.getIsNegativeOnActiveDCMView();

    if (typeof isNagative !== "boolean") {
      return "";
    }
    return isNagative;
  };

  /**
   * @method handleDefaultWindow
   * @param toolname  도구 이름
   * @description WindowLevel을 Default Window로 변경``
   */
  handleDefaultWindow = (event) => {
    event.preventDefault();
    pubsub.publish(CustomEvent.Messages.CONTRAST_DEFAULT, null);
    const { gridLayoutStore, toolbarStore } = this.props;
    gridLayoutStore.setContrastOptionNameOnActiveDCMView("default-window");
    toolbarStore.activateTool("Contrast");
  };

  /**
   * @method handleFullDynamicWindow
   * @param {*} toolname 도구 이름
   * @description WindowLevel을 FullDynamic Window로 변경
   */
  handleFullDynamicWindow = (event) => {
    event.preventDefault();
    pubsub.publish(CustomEvent.Messages.CONTRAST_FULL_DYNAMIC, null);
    const { gridLayoutStore, toolbarStore } = this.props;
    gridLayoutStore.setContrastOptionNameOnActiveDCMView("full-dynamic");
    toolbarStore.activateTool("Contrast");
  };

  /**
   * @method handleNegative
   * @description WindowLevel을 Negative 상태로 변경
   */
  handleNegative = (event) => {
    const { gridLayoutStore, toolbarStore } = this.props;
    event.preventDefault();

    pubsub.publish(CustomEvent.Messages.RENDER_INVERT, null);
    toolbarStore.activateTool("Contrast");
    gridLayoutStore.toggleNegativeOnActiveDCMView();
  };


  handleCustomWindow = async (event) => {
    event.preventDefault();

    const result = await Swal.fire({
      title: 'Custom Window',
      html:
        '<input id="swal-wl" class="swal2-input" placeholder="Window Level (WL)" />' +
        '<input id="swal-ww" class="swal2-input" placeholder="Window Width (WW)" />',
      focusConfirm: false,
      showCancelButton: true,
      confirmButtonText: 'Apply',
      preConfirm: () => {
        const wl = parseFloat(document.getElementById('swal-wl').value);
        const ww = parseFloat(document.getElementById('swal-ww').value);

        if (isNaN(wl) || isNaN(ww)) {
          Swal.showValidationMessage('Please enter numeric values for both WL and WW.');
          return false;
        }

        return { wl, ww };
      }
    });

    if (result.isConfirmed) {
      const payload = {
        value: result.value,
        type: "window",
        name: "custom-window",
      };

      pubsub.publish(CustomEvent.Messages.CONTRAST_VIEWPORT, payload);

      const { gridLayoutStore, toolbarStore } = this.props;
      gridLayoutStore.setContrastOptionNameOnActiveDCMView("custom-window");
      toolbarStore.activateTool("Contrast");
    }
  };

  /**
   * @method renderBasicWindowLevelMenuItem
   * @description Default/dyanic window 메뉴 렌더링
   */
  renderBasicWindowLevelMenuItem = () => {
    const { hotkeyStore } = this.props;
    const keymap = hotkeyStore.getKeysFromCommandName([
      "SELECT_CONTRAST_DEFAULT",
      "SELECT_CONTRAST_FULLDYNAMIC",
    ]);

    return (
      <React.Fragment>
        <Dropdown.Item
          key={"default-window-item"}
          bsPrefix="toolbar"
          className="dropdown-menu--toolbar__item__content"
          eventKey="0"
          hotkey={keymap["SELECT_CONTRAST_DEFAULT"].toUpperCase() || ""}
          activeIcon={SVGIcons.SVGDropdownCheckmarkIcon}
          onClick={this.handleDefaultWindow}
          active={this.isActive("default-window")}
          as="div"
        >
          Default Window
        </Dropdown.Item>
        <Dropdown.Item
          key={"full-dynamic-item"}
          bsPrefix="toolbar"
          className="dropdown-menu--toolbar__item__content"
          eventKey="9"
          hotkey={keymap["SELECT_CONTRAST_FULLDYNAMIC"].toUpperCase() || ""}
          activeIcon={SVGIcons.SVGDropdownCheckmarkIcon}
          onClick={this.handleFullDynamicWindow}
          active={this.isActive("full-dynamic")}
          as="div"
        >
          Full Dynamic
        </Dropdown.Item>
        {/* ADD */}
        <Dropdown.Item
          key="custom-window-item"
          bsPrefix="toolbar"
          className="dropdown-menu--toolbar__item__content"
          eventKey="99"
          hotkey=""
          activeIcon={SVGIcons.SVGDropdownCheckmarkIcon}
          onClick={this.handleCustomWindow}
          active={this.isActive("custom-window")}
          as="div"
        >
          Custom Window
        </Dropdown.Item>
      </React.Fragment>
    );
  };

  /**
   * @method renderPrefixWindowLevelMenuItem
   * @description Prefix windowlevel menuitem 렌더링
   */
  renderPrefixWindowLevelMenuItem = () => {
    const that = this;
    const renderedMenu = [];
    const { hotkeyStore } = this.props;
    const { gridLayoutStore } = this.props;
    const modality = gridLayoutStore.getModalityForActiveDCMView();

    if (modality === "") {
      return;
    }
    if (Config.presetWindow.hasOwnProperty(modality) === false) {
      return;
    }
    const windowHotkeys = Config.presetWindow[modality].map((value, index) => {
      return new HotkeyModel(
        value.funcKey,
        value.name,
        value.hotkey,
        "keydown"
      );
    });
    hotkeyStore.registerHotkeys(windowHotkeys);

    const newHandlers = Config.presetWindow[modality].map((value, index) => {
      if (value.type.toLowerCase() === "window") {
        return {
          funcKey: value.funcKey,
          name: value.name,
          handler: (event) => {
            const payload = {
              value: {
                wl: value.value.windowLevel,
                ww: value.value.windowWidth,
              },
              type: "window",
              name: value.name,
            };
            pubsub.publish(CustomEvent.Messages.CONTRAST_VIEWPORT, payload);
            Config.rootStore.gridLayoutStore.setContrastOptionNameOnActiveDCMView(
              payload.name
            );
            Config.rootStore.toolbarStore.setViewportToolType(3 /*Contrast*/);
          },
        };
      } else if (value.type.toLowerCase() === "displayedmaximumvalue") {
        return {
          funcKey: value.funcKey,
          name: value.name,
          handler: (event) => {
            const payload = {
              value: value.value,
              type: "displayedmaximumvalue",
              name: value.name,
            };
            pubsub.publish(CustomEvent.Messages.CONTRAST_VIEWPORT, payload);
            Config.rootStore.gridLayoutStore.setContrastOptionNameOnActiveDCMView(
              payload.name
            );
            Config.rootStore.toolbarStore.setViewportToolType(3 /*Contrast*/);
          },
        };
      }
    });
    hotkeyStore.registerHandlers(newHandlers);
    Config.presetWindow[modality].forEach(
      function (element, i) {
        const {
          name,
          funcKey,
          type,
          value,
          windowLevel,
          windowWidth,
          hotkey,
        } = element;

        let shortcutKey = hotkey || "";

        const handleMenuItemClick = (event) => {
          const prefixName = name;
          event.preventDefault();

          if (type.toLowerCase() === "window") {
            const payload = {
              value: {
                wl: value.windowLevel,
                ww: value.windowWidth,
              },
              type: "window",
              name: name,
            };
            pubsub.publish(CustomEvent.Messages.CONTRAST_VIEWPORT, payload);
            const { gridLayoutStore, toolbarStore } = that.props;
            gridLayoutStore.setContrastOptionNameOnActiveDCMView(prefixName);

            Config.rootStore.toolbarStore.setViewportToolType(3 /*Contrast*/);
            toolbarStore.activateTool("Contrast");
          } else if (type.toLowerCase() === "displayedmaximumvalue") {
            const prefixName = name;
            event.preventDefault();

            // if (type.toLowerCase() === "window") {
            const payload = {
              value: value,
              type: "displayedmaximumvalue",
              name: name,
            };
            pubsub.publish(CustomEvent.Messages.CONTRAST_VIEWPORT, payload);
            const { gridLayoutStore, toolbarStore } = that.props;
            gridLayoutStore.setContrastOptionNameOnActiveDCMView(prefixName);

            Config.rootStore.toolbarStore.setViewportToolType(3 /*Contrast*/);
            toolbarStore.activateTool("Contrast");
            // }
          }
        };
        renderedMenu.push(
          <Dropdown.Item
            key={name + "-item"}
            bsPrefix="toolbar"
            className="dropdown-menu--toolbar__item__content"
            eventKey={shortcutKey}
            hotkey={shortcutKey}
            activeIcon={SVGIcons.SVGDropdownCheckmarkIcon}
            onClick={handleMenuItemClick}
            active={this.isActive(name)}
            as="div"
          >
            {name}
          </Dropdown.Item>
        );
      }.bind(this)
    );

    return renderedMenu;
  };
  /**
   * @method renderPrefixWindowLevelMenuItem
   * @description negavie menuitem 렌더링
   */
  renderNagativeMenuItem = () => {
    const { hotkeyStore, gridLayoutStore } = this.props;
    const keymap = hotkeyStore.getKeysFromCommandName([
      "SELECT_CONTRAST_NEGATIVE",
    ]);
    return (
      <Dropdown.Item
        key="isNagative-item"
        bsPrefix="toolbar"
        className="dropdown-menu--toolbar__item__content"
        eventKey="8"
        hotkey={keymap["SELECT_CONTRAST_NEGATIVE"].toUpperCase() || ""}
        activeIcon={SVGIcons.SVGDropdownCheckmarkIcon}
        onClick={this.handleNegative}
        active={gridLayoutStore.getIsNegativeOnActiveDCMView()}
        as="div"
      >
        Negative
      </Dropdown.Item>
    );
  };
  /**
   * @method renderDropdownMenu
   * @description dropdownmenu 렌더링
   */
  renderDropdownMenu = () => (
    <Dropdown.Menu bsPrefix="dropdown-menu--toolbar">
      {this.renderBasicWindowLevelMenuItem()}
      <Separator />
      {this.renderPrefixWindowLevelMenuItem()}
      <Separator />
      {this.renderNagativeMenuItem()}
    </Dropdown.Menu>
  );
  render() {
    return <React.Fragment>{this.renderDropdownMenu()}</React.Fragment>;
  }
}

export default ContrastDropdownContainer;
